/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_No_Voices_Match_FiltersInputs */

const en_mobile_no_voices_match_filters = /** @type {(inputs: Mobile_No_Voices_Match_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No voices match these filters.`)
};

const es_mobile_no_voices_match_filters = /** @type {(inputs: Mobile_No_Voices_Match_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguna voz coincide con estos filtros.`)
};

/**
* | output |
* | --- |
* | "No voices match these filters." |
*
* @param {Mobile_No_Voices_Match_FiltersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_no_voices_match_filters = /** @type {((inputs?: Mobile_No_Voices_Match_FiltersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_No_Voices_Match_FiltersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_no_voices_match_filters(inputs)
	return en_mobile_no_voices_match_filters(inputs)
});